/** Clerk's "seats are full" error codes, across its API versions. */
export const SEAT_LIMIT_CODES = new Set([
  'max_allowed_memberships_reached',
  'organization_max_memberships_reached',
  'organization_membership_quota_exceeded',
]);

/** What a Free or trial workspace sees once its seats are taken: more seats
 *  need a paid plan, since only a paid plan can buy them. */
export function fullSeatsMessage(seats: number, onTrial: boolean) {
  return {
    title: `Your ${onTrial ? 'trial' : 'Free plan'} includes ${seats} seat${seats === 1 ? '' : 's'}`,
    description: onTrial
      ? 'Start your paid plan to add more.'
      : 'Upgrade to a paid plan to add more.',
  };
}
